import { useParams } from 'react-router-dom';
import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { fetchWidget } from 'api/widgets';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { widgetQueryKeys } from 'queries/widget-query-keys';
import { Widget } from 'types/domain';

interface Options
    extends Omit<
        UseSuspenseQueryOptions<Widget | null, DefaultError, Widget | null, any>,
        'queryKey'
    > {
    enabled?: boolean;
}

const useCurrentWidget = (options: Options = {}) => {
    const { enabled = true, ...restOptions } = options;
    const { accountId } = useCurrentAccount();
    const queryParams = useParams<{ widgetId?: string }>();
    const widgetId = queryParams.widgetId ? parseInt(queryParams.widgetId) : null;

    return useSuspenseQuery({
        queryKey: widgetQueryKeys.widget(accountId, widgetId as number),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchWidget({ accountId, widgetId: widgetId as number }),
                enabled && typeof widgetId === 'number',
            ),
        ...restOptions,
    });
};

export { useCurrentWidget };
